import { render, staticRenderFns } from "./RequestedProducts.vue?vue&type=template&id=ffc0947e&scoped=true&"
import script from "./RequestedProducts.vue?vue&type=script&lang=js&"
export * from "./RequestedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc0947e",
  null
  
)

export default component.exports